import { createActionGroup, emptyProps, props } from "@ngrx/store";
import {
    InvoiceSubscriptionRequest,
    SubscriptionPlan,
} from "../models/company-entitlement.models";

export const SubscriptionsActions = createActionGroup({
    source: "Subscriptions",
    events: {
        "Page Opened": emptyProps(),
        "Plans Loaded": props<{ plans: SubscriptionPlan[] }>(),
        "Plans Load Failed": props<{ message: string }>(),
        "Plan Selected": props<{ priceId: string }>(),
        "Checkout Cancelled": emptyProps(),
        "Invoice Checkout Submitted": props<{
            clientId: string;
            request: InvoiceSubscriptionRequest;
        }>(),
        "Checkout Succeeded": emptyProps(),
        "Checkout Failed": props<{ message: string }>(),
        Reset: emptyProps(),
    },
});
